import React from 'react'
import WizardNavigationContainer from './WizardNavigationContainer'

const WizardNavigation = props => (
  <WizardNavigationContainer data-test="component-wizard-navigation-container" {...props} />
)

export default WizardNavigation
